module.exports = __webpack_public_path__ + "img/acc3.cdb23a67.png";